module.exports = __webpack_public_path__ + "static/media/loading-title.d64bd6da.png";